import { useEditAvailabilityBook } from './useEditAvailabilityBook';
import { useFetchAvailabilitiesCount } from './useFetchAvailabilitiesCount';
import { useFetchManySchedulerAvailabilities } from './useFetchManySchedulerAvailabilities';

export * from './useAvailabilitySchedulerByContentRange';

export * from './types';
export { keys as availabilityModelKeys } from './crud';

export { useAvailabilityScheduler } from './useAvailabilityScheduler';
export const useAvailabilityManyScheduler = useFetchManySchedulerAvailabilities;
export const useAvailabilityUpdateOneBook = useEditAvailabilityBook;
export const useAvailabilitiesCount = useFetchAvailabilitiesCount;
